import { render, staticRenderFns } from "./SuggestionLoader.vue?vue&type=template&id=d526c562&scoped=true"
import script from "./SuggestionLoader.vue?vue&type=script&lang=ts"
export * from "./SuggestionLoader.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionLoader.vue?vue&type=style&index=0&id=d526c562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d526c562",
  null
  
)

export default component.exports